<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.os_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="os_emname">
            <label class="weui-form-preview__label">{{customLabel.os_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.os_emname}}
              <call-mobile :em-id="form.main.os_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="os_department">
            <label class="weui-form-preview__label">{{customLabel.os_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_sealtype">
            <label class="weui-form-preview__label">{{customLabel.os_sealtype || "印章类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_sealtype}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_usetime">
            <label class="weui-form-preview__label">{{customLabel.os_usetime || "用印时间"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.os_usetime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_filename">
            <label class="weui-form-preview__label">{{customLabel.os_filename || "文件名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_filename}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_filenum">
            <label class="weui-form-preview__label">{{customLabel.os_filenum || "文件份数"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_filenum}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_filetype">
            <label class="weui-form-preview__label">{{customLabel.os_filetype || "文件类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_filetype}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_custname">
            <label class="weui-form-preview__label">{{customLabel.os_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_custname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_archive">
            <label class="weui-form-preview__label">{{customLabel.os_archive || "回传要求"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_archive}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_vendname">
            <label class="weui-form-preview__label">{{customLabel.os_vendname || "供应商名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_vendname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_iocode">
            <label class="weui-form-preview__label">{{customLabel.os_iocode || "来源单号"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_iocode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_state">
            <label class="weui-form-preview__label">{{customLabel.os_state || "用印状态"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_state}}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_remark">
            <label class="weui-form-preview__label">{{customLabel.os_remark || "用印事由"}}</label>
            <span class="weui-form-preview__value">{{form.main.os_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.os_attach" />
      <file-list v-model="form.main.os_attach_col" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/seal_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/officialseal",
      codeField: "os_code",
      statusField: "os_statuscode",
      caller: "OfficialSeal",
      xtype: "oa-officialseal-formpanel",
    };
  }
};
</script>